export default "__VITE_ASSET__5dcd55b1__"